// AUTO-GENERATED by scripts/prepare-brand.mjs for NEXT_PUBLIC_BRAND=skufstore — do not edit
export { default as brand } from './brands/skufstore'
